import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setClosePacienteModal, setFullScreenPacModal } from "../redux/default/actions.js";

import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { sleep } from '../helpers/utils.js';
import { isIPad13, isMobile, isTablet } from 'react-device-detect';

const styleObject = {
    width: '270px',
};

class RightSideBar extends Component {
    rightBarNodeRef;

    static defaultProps = {
        title: 'Right Sidebar'
    }

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.hideBar = this.hideBar.bind(this);
        this.state = {}
    }

    /**
     * 
     */
    componentWillMount = () => {
        //document.addEventListener('mousedown', this.handleOtherClick, false);
    }

    /**
     * 
     */
    componentWillUnmount = () => {
        document.body.classList.remove('noOverflow');
        // document.removeEventListener('mousedown', this.handleOtherClick, false);
    }
    /**
     * Handles the close
     */
    handleClose = (e) => {
        document.body.classList.remove('noOverflow');

        e.preventDefault();
        if (this.props.rightSidebarToggle) {
            this.props.rightSidebarToggle();
            this.props.closePacModal()
        }
        this.hide();
    }

    /**
     * Handle the click anywhere in doc
     */
    handleOtherClick = (e) => {
        document.body.classList.remove('noOverflow');

        if (this.rightBarNodeRef.contains(e.target))
            return;
        // else hide the right sidebar
        this.hide();
    }

    /**
     * Hide rightside bar
     */
    hide() {
        document.body.classList.remove("right-bar-enabled");
    }

    hideBar() {
        this.hide()
        this.props.fullScreenPacModal()
    }

    render() {
        const title = this.props.title;
        const component = this.props.children || null;
        const isMobileAux = isMobile || isTablet || isIPad13

        return (
            <React.Fragment>
                <div className="right-bar" ref={node => this.rightBarNodeRef = node} style={isMobileAux ? styleObject : {}}>
                    <div className="rightbar-title">
                        <Link to="#" className="right-bar-toggle float-right" onClick={this.handleClose}>
                            {/*  <i className="dripicons-cross noti-icon"></i> */}
                            <i className="fa fa-times"></i>
                        </Link>

                        {isMobileAux && <Link to="#" className="right-bar-toggle float-right mr-2" onClick={this.hideBar}>
                            <i className="fas fa-arrow-right"></i>
                        </Link>}
                        <h5 className="m-0 text-white">Conversas</h5>
                    </div>
                    <PerfectScrollbar>
                        {component}
                    </PerfectScrollbar>
                </div>
                <div className="rightbar-overlay"></div>
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        closePacModal: async () => {
            dispatch(setClosePacienteModal(true))
            await sleep(100)
            dispatch(setClosePacienteModal(false))
        },
        fullScreenPacModal: () => {
            dispatch(setFullScreenPacModal(true))
        }
    }
};

export default connect(null, mapDispatchToProps)(RightSideBar);